var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row justify-content-center" },
    [
      _vm.$route.params.type === "request"
        ? [
            !_vm.requested
              ? [
                  _vm.user.profile
                    ? [
                        !_vm.mireraTeacher
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "form-container d-flex flex-column align-items-center",
                                staticStyle: { "--wide": "0" },
                              },
                              [
                                _c("h2", { staticClass: "title-text" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("title.teacherRequest")) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  { staticClass: "subtitle-text pt-4 mb-0" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$t("message.enterContactInfo")
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mx-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col px-4" },
                                    [
                                      _c(
                                        "ValidationObserver",
                                        { ref: "formObserver" },
                                        [
                                          _c("v-input", {
                                            staticClass:
                                              "input-w-default mb-0 mt-2",
                                            attrs: {
                                              ind: "0",
                                              type: "tel",
                                              placeholder:
                                                _vm.$t("placeholder.phone"),
                                              icon: _vm.$getInputIcon(
                                                _vm.phone,
                                                "phone"
                                              ),
                                              rules: "required|phone",
                                            },
                                            model: {
                                              value: _vm.phone,
                                              callback: function ($$v) {
                                                _vm.phone = $$v
                                              },
                                              expression: "phone",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-input", {
                                            staticClass:
                                              "input-w-default mb-0 mt-2",
                                            attrs: {
                                              ind: "1",
                                              type: "text",
                                              placeholder:
                                                _vm.$t("placeholder.work"),
                                              icon: _vm.$getInputIcon(
                                                _vm.work,
                                                "work"
                                              ),
                                              rules: "required",
                                            },
                                            model: {
                                              value: _vm.work,
                                              callback: function ($$v) {
                                                _vm.work = $$v
                                              },
                                              expression: "work",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-input", {
                                            staticClass:
                                              "input-w-default mb-0 mt-2",
                                            attrs: {
                                              ind: "2",
                                              type: "text",
                                              placeholder: _vm.$t(
                                                "placeholder.position"
                                              ),
                                              icon: _vm.$getInputIcon(
                                                _vm.position,
                                                "position"
                                              ),
                                              rules: "required",
                                            },
                                            model: {
                                              value: _vm.position,
                                              callback: function ($$v) {
                                                _vm.position = $$v
                                              },
                                              expression: "position",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-input", {
                                            staticClass:
                                              "input-w-default mb-0 mt-2",
                                            attrs: {
                                              ind: "3",
                                              type: "text",
                                              placeholder: _vm.$t(
                                                "placeholder.comment"
                                              ),
                                              icon: _vm.$getInputIcon(
                                                _vm.comment,
                                                "comment"
                                              ),
                                            },
                                            model: {
                                              value: _vm.comment,
                                              callback: function ($$v) {
                                                _vm.comment = $$v
                                              },
                                              expression: "comment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "enter-button w-75 mb-2",
                                          on: { click: _vm.sendRequest },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("button.send")) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "h2",
                              {
                                staticClass: "text-white font-weight-light",
                                staticStyle: { "text-align": "center" },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("error.alreadyTeacher")) +
                                    "\n                "
                                ),
                              ]
                            ),
                      ]
                    : _vm._e(),
                ]
              : _c("h5", { staticClass: "text-white mt-5 mb-3" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.requestSent")) +
                      "\n        "
                  ),
                ]),
          ]
        : [
            !_vm.registered
              ? [
                  !_vm.user.profile
                    ? _c(
                        "div",
                        {
                          staticClass: "form-container",
                          staticStyle: { "--wide": "1" },
                        },
                        [
                          _c(
                            "h2",
                            { staticClass: "title-text wide-title-text px-4" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("title.teacherRegister")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ValidationObserver",
                            { ref: "registerObserver" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap justify-content-around",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "4",
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "placeholder.surname"
                                          ),
                                          icon: _vm.$getInputIcon(
                                            _vm.surname,
                                            "name"
                                          ),
                                          rules: "required",
                                        },
                                        model: {
                                          value: _vm.surname,
                                          callback: function ($$v) {
                                            _vm.surname = $$v
                                          },
                                          expression: "surname",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "5",
                                          type: "text",
                                          placeholder:
                                            _vm.$t("placeholder.name"),
                                          icon: _vm.$getInputIcon(
                                            _vm.name,
                                            "name"
                                          ),
                                          rules: "required",
                                        },
                                        model: {
                                          value: _vm.name,
                                          callback: function ($$v) {
                                            _vm.name = $$v
                                          },
                                          expression: "name",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "8",
                                          type: "email",
                                          placeholder:
                                            _vm.$t("placeholder.email"),
                                          icon: _vm.$getInputIcon(
                                            _vm.mail,
                                            "email"
                                          ),
                                          debounce: 500,
                                          rules:
                                            "required|email|emailNotExists",
                                        },
                                        model: {
                                          value: _vm.mail,
                                          callback: function ($$v) {
                                            _vm.mail = $$v
                                          },
                                          expression: "mail",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "6",
                                          type: "password",
                                          name: "password",
                                          placeholder: _vm.$t(
                                            "placeholder.password"
                                          ),
                                          icon: _vm.$getInputIcon(
                                            _vm.password,
                                            "password"
                                          ),
                                          rules: { required: true, min: 6 },
                                          autocomplete: "new-password",
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function ($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "7",
                                          type: "password",
                                          name: "passwordConfirm",
                                          placeholder: _vm.$t(
                                            "placeholder.repeatPassword"
                                          ),
                                          icon: _vm.$getInputIcon(
                                            _vm.passwordConfirm,
                                            "password"
                                          ),
                                          rules: "required|confirmed:password",
                                          autocomplete: "new-password",
                                        },
                                        model: {
                                          value: _vm.passwordConfirm,
                                          callback: function ($$v) {
                                            _vm.passwordConfirm = $$v
                                          },
                                          expression: "passwordConfirm",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "9",
                                          type: "tel",
                                          placeholder:
                                            _vm.$t("placeholder.phone"),
                                          icon: _vm.$getInputIcon(
                                            _vm.phone,
                                            "phone"
                                          ),
                                          rules: "required|phone",
                                        },
                                        model: {
                                          value: _vm.phone,
                                          callback: function ($$v) {
                                            _vm.phone = $$v
                                          },
                                          expression: "phone",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "10",
                                          type: "text",
                                          placeholder:
                                            _vm.$t("placeholder.work"),
                                          icon: _vm.$getInputIcon(
                                            _vm.work,
                                            "work"
                                          ),
                                          rules: "required",
                                        },
                                        model: {
                                          value: _vm.work,
                                          callback: function ($$v) {
                                            _vm.work = $$v
                                          },
                                          expression: "work",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "11",
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "placeholder.position"
                                          ),
                                          icon: _vm.$getInputIcon(
                                            _vm.position,
                                            "position"
                                          ),
                                          rules: "required",
                                        },
                                        model: {
                                          value: _vm.position,
                                          callback: function ($$v) {
                                            _vm.position = $$v
                                          },
                                          expression: "position",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-input", {
                                        staticClass: "input-w-default",
                                        attrs: {
                                          ind: "12",
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "placeholder.commentForAdmin"
                                          ),
                                          icon: _vm.$getInputIcon(
                                            _vm.comment,
                                            "comment"
                                          ),
                                        },
                                        model: {
                                          value: _vm.comment,
                                          callback: function ($$v) {
                                            _vm.comment = $$v
                                          },
                                          expression: "comment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: { rules: { isTrue: true }, slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              staticClass:
                                                "text-white small agreements-checkbox",
                                              attrs: {
                                                id: "confirmUserAgreementAndPrivacyPolicy",
                                              },
                                              model: {
                                                value:
                                                  _vm.confirmUserAgreementAndPrivacyPolicy,
                                                callback: function ($$v) {
                                                  _vm.confirmUserAgreementAndPrivacyPolicy =
                                                    $$v
                                                },
                                                expression:
                                                  "confirmUserAgreementAndPrivacyPolicy",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.acceptTerms"
                                                    )
                                                  ) +
                                                  "\n                            \n                            "
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "text-link",
                                                  attrs: {
                                                    to: "/user-agreement",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "title.userAgreementGenitive"
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                            \n                            " +
                                                  _vm._s(
                                                    _vm.$t("message.and")
                                                  ) +
                                                  "\n                            \n                            "
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "text-link",
                                                  attrs: {
                                                    to: "/privacy-policy",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "title.privacyPolicyGenitive"
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          errors.length
                                            ? _c(
                                                "b-popover",
                                                {
                                                  attrs: {
                                                    target:
                                                      "confirmUserAgreementAndPrivacyPolicy",
                                                    placement: "left",
                                                    variant: "danger",
                                                    show: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.confirmTerms"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3676914467
                                ),
                              }),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: { rules: { isTrue: true }, slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              staticClass:
                                                "text-white small mx-auto agreements-checkbox",
                                              attrs: {
                                                id: "confirmPersonalDataAgreement",
                                              },
                                              model: {
                                                value:
                                                  _vm.confirmPersonalDataAgreement,
                                                callback: function ($$v) {
                                                  _vm.confirmPersonalDataAgreement =
                                                    $$v
                                                },
                                                expression:
                                                  "confirmPersonalDataAgreement",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.acceptPersonalDataAgreement"
                                                    )
                                                  ) +
                                                  "\n                            \n                            "
                                              ),
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "text-link",
                                                  attrs: {
                                                    to: "/personal-data-agreement",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "title.personalDataAgreement"
                                                        )
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          errors.length
                                            ? _c(
                                                "b-popover",
                                                {
                                                  attrs: {
                                                    target:
                                                      "confirmPersonalDataAgreement",
                                                    placement: "left",
                                                    variant: "danger",
                                                    show: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.confirmTerms"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2305106648
                                ),
                              }),
                              _vm._v(" "),
                              _vm.error !== ""
                                ? _c(
                                    "b-form-invalid-feedback",
                                    { staticClass: "center-element" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.error) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass:
                                    "text-white small mailing-checkbox",
                                  attrs: { id: "acceptedMailing" },
                                  model: {
                                    value: _vm.acceptedMailing,
                                    callback: function ($$v) {
                                      _vm.acceptedMailing = $$v
                                    },
                                    expression: "acceptedMailing",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        `${_vm.$t("message.acceptedMailing")} `
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "center-element enter-button px-5 mb-2",
                                  attrs: {
                                    disabled:
                                      !_vm.confirmUserAgreementAndPrivacyPolicy ||
                                      !_vm.confirmPersonalDataAgreement,
                                  },
                                  on: { click: _vm.register },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("button.register")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "h2",
                        {
                          staticClass:
                            "text-white font-weight-light text-center",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("error.alreadyRegistered")) +
                              "\n            "
                          ),
                        ]
                      ),
                ]
              : _c("div", { staticClass: "col mb-3 text-center" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("h5", { staticClass: "text-white mt-5" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.lastStepToRegister")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("h6", { staticClass: "text-white" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(`${_vm.$t("message.checkActivationMail")}: `)
                      ),
                      _c("strong", [_vm._v(_vm._s(_vm.mail))]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.expireDateWarning")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }